import moment from "moment"

export const formattedDate = (oldDate: string) => {
  oldDate = oldDate.replace(/\./g, "-")

  const newDate = moment(oldDate).format("MMM D, YYYY")

  return newDate
}
